import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import Background from "../../Background";
import { register } from "../../../Services/userService";
import { useDispatch, useSelector } from "react-redux";
import IndexNav from "../../IndexNav";
import {
  BgContainer,
  Container,
  FormSection,
  FormCard,
  Form,
  Title,
  Subtitle,
  Input,
  Button,
  Text,
  Hr,
  Link,
} from "./Styled";

const Register = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { pending } = useSelector((state) => state.user);
  const [userInformations, setUserInformations] = useState({
    name: "",
    organization: "",
    email: "",
    password: "",
    repassword: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    await register(userInformations, dispatch);
  };

  return (
    <>
      <IndexNav />
      <BgContainer>
        <Background />
      </BgContainer>
      <Container>
        <FormSection>
          <FormCard>
            <Form onSubmit={handleSubmit}>
              <Title>Create your account</Title>
              <Subtitle>Set up your workspace and invite your team in minutes.</Subtitle>
              <Link fontSize="0.8rem" onClick={() => history.push("/")}>
                Back to home
              </Link>
              <Input
                type="text"
                placeholder="Full name"
                required
                value={userInformations.name}
                onChange={(e) =>
                  setUserInformations({
                    ...userInformations,
                    name: e.target.value,
                  })
                }
              />
              <Input
                type="text"
                placeholder="Organization or team name"
                required
                value={userInformations.organization}
                onChange={(e) =>
                  setUserInformations({
                    ...userInformations,
                    organization: e.target.value,
                  })
                }
              />
              <Input
                type="email"
                placeholder="Work email"
                required
                value={userInformations.email}
                onChange={(e) =>
                  setUserInformations({
                    ...userInformations,
                    email: e.target.value,
                  })
                }
              />
              <Input
                type="password"
                placeholder="Create password"
                required
                value={userInformations.password}
                onChange={(e) =>
                  setUserInformations({
                    ...userInformations,
                    password: e.target.value,
                  })
                }
              />
              <Input
                type="password"
                placeholder="Confirm password"
                required
                value={userInformations.repassword}
                onChange={(e) =>
                  setUserInformations({
                    ...userInformations,
                    repassword: e.target.value,
                  })
                }
              />
              <Text>
                By signing up, you agree to our{" "}
                <Link fontSize="0.75rem" onClick={() => history.push("/terms")}>
                  Terms of Service
                </Link>{" "}
                and{" "}
                <Link fontSize="0.75rem" onClick={() => history.push("/privacy")}>
                  Privacy Policy
                </Link>
                .
              </Text>
              <Button type="submit" disabled={pending}>
                {pending ? "Creating account..." : "Create account"}
              </Button>
              <Hr />
              <Link fontSize="0.85rem" onClick={() => history.push("/login")}>
                Already using PepHub Board? Log in
              </Link>
            </Form>
          </FormCard>
        </FormSection>
      </Container>
    </>
  );
};

export default Register;
